import { Box } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useOverlay } from "@toss/use-overlay";
import { customEvent, Spacing } from "goi_common";
import { BaseStack, baseColors, BaseButton } from "goi_common/src/design-system";

import UrgentModal from "@/components/common/Modal/UrgentModal";

/**
 * 지역 장례식장 목록 내 선택 서포트 리드 카드 - 목록 중간(mid)·끝(end) 두 지점에서 사용.
 * action에 따라 라우트 이동(비교④ 등) 또는 임종 긴급 모달(UrgentModal)을 연다.
 */
type RegionLeadTrigger =
  | "list_mid_card-uv_mtch_rqst"
  | "list_end_card-uv_mtch_rqst"
  | "list_mid_card-opn_mdl";

interface RegionLeadSupportCardProps {
  title: string;
  description: string;
  buttonText: string;
  trigger: RegionLeadTrigger;
  /** route: href로 이동 / urgent: 임종 긴급 모달(UrgentModal) */
  action: { type: "route"; href: string } | { type: "urgent" };
}

function RegionLeadSupportCard({
  title,
  description,
  buttonText,
  trigger,
  action,
}: RegionLeadSupportCardProps) {
  const router = useRouter();
  const overlay = useOverlay();

  const onClick = () => {
    customEvent({
      newGtm: { path: "parlor_region", trigger_and_target: trigger },
    });
    if (action.type === "urgent") {
      overlay.open(({ isOpen, close: onClose }) => (
        <UrgentModal isOpen={isOpen} onClose={onClose} />
      ));
      return;
    }
    router.push(action.href);
  };

  return (
    <BaseStack
      width="100%"
      p={20}
      borderRadius="12px"
      border={`1px solid ${baseColors.line_normal}`}
      bg={baseColors.background_normal}
    >
      <Box className="body_1_normal_sb" color={baseColors.label_normal} wordBreak="keep-all">
        {title}
      </Box>
      <Spacing gap={6} />
      <Box className="label_1_r" color={baseColors.label_assistive_2} wordBreak="keep-all">
        {description}
      </Box>
      <Spacing gap={14} />
      <BaseButton type="primary" size="medium" onClick={onClick}>
        <Box className="body_2_normal_sb">{buttonText}</Box>
      </BaseButton>
    </BaseStack>
  );
}

export default RegionLeadSupportCard;
